module.exports = __webpack_public_path__ + "img/close_black.fba9818e.svg";